import { RendererBaseProps } from '../index';
import { ImagePage } from './image-page';

export const ImageRenderer = ({
  docId,
  getPageDimensions,
  visiblePages,
  getPagePosition,
  highlights,
  highlightedFactId,
  onHighlightClick,
  highlightedChunkId,
  totalHeight,
  maxPageWidth: providedMaxPageWidth,
  isSelectionMode,
  onSelectionComplete,
  maintainSelection,
  activeSelection,
}: RendererBaseProps) => {
  // Use provided maxPageWidth if available, otherwise calculate from visible pages
  // Using the provided value (calculated from ALL pages) prevents horizontal scroll jumps
  // when new pages with different widths come into view
  const maxPageWidth =
    providedMaxPageWidth ??
    visiblePages.reduce((max, pageNumber) => {
      const pageDims = getPageDimensions(pageNumber);
      return Math.max(max, pageDims.width);
    }, 0);

  // Add padding (20px on each side) for the grey border
  const containerWidth = maxPageWidth + 40;

  return (
    <div className="relative bg-gray-100" style={{ height: totalHeight, width: containerWidth, minWidth: '100%' }}>
      {visiblePages.map((pageNumber) => {
        const pageDims = getPageDimensions(pageNumber);

        return (
          <ImagePage
            key={pageNumber}
            pageNumber={pageNumber}
            top={getPagePosition(pageNumber)}
            dimensions={{ height: pageDims.height, width: pageDims.width }}
            highlights={highlights}
            highlightedFactId={highlightedFactId}
            onHighlightClick={onHighlightClick}
            highlightedChunkId={highlightedChunkId}
            docId={docId}
            isSelectionMode={isSelectionMode}
            onSelectionComplete={onSelectionComplete}
            maintainSelection={maintainSelection}
            activeSelection={activeSelection}
          />
        );
      })}
    </div>
  );
};
